export const resolveRoute = (baseUrl) => `${baseUrl}/return/:fulfillmentId`;
